export default "__VITE_ASSET__6c2835bf__"